import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleInput, SingleSelect, SingleDatePickerInput, SELECT_VAL_TYPE_STRING, SingleText, CheckDisable, SingleRedio } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { ReqLeagueDetail } from '../../../../../item/MyStat/ItemLeague';
import { api_addLeague, api_getLeagueDetail, api_checkLeagueName } from '../../../../../api/MyStat/apiLeague';
import { RespClient } from '../../../../../item/MyStat/ItemClient';
import { api_getTeamListArray } from '../../../../../api/MyStat/apiTeam';
import { ReqTeamListArray } from '../../../../../item/MyStat/ItemTeam';
import { api_addClient, api_updateClient } from '../../../../../api/MyStat/apiClient';
import { getval2Token } from '../../../../Login/Auth';


export const isDisableItems = [
  { "val": 1, "name": "是" },
  { "val": 0, "name": "否" },
]

export function ClientAdd({ id, setIsLoading, isEdit, isAdd = false }) {

  const [tokenId, setTokenId] = useState("")
  const [team_attr, set_team_attr] = useState([])

  const [team_id, set_team_id] = useState("")
  const [team_name, set_team_name] = useState("")
  const [admin, set_admin] = useState("")
  const [startDate, set_startDate] = useState("")
  const [actCodeCap, set_actCodeCap] = useState(75)
  const [endDate, set_endDate] = useState("")

  const [activation, set_activation] = useState("")
  

  const [dateError, setDateError] = useState(false)
  const [dateErrorArr, setDateErrorArr] = useState([])

  

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("ClientEdit", id)
      console.log(obj)
      set_team_id(obj.team_id)
      set_team_name(obj.team_name)
      set_admin(obj.admin)
      set_startDate(moment(obj.startDate).format('YYYY-MM-DD'))
      set_endDate(moment(obj.endDate).format('YYYY-MM-DD'))
      set_actCodeCap(obj.actCodeCap)
      set_activation(obj.activation)
    } else {
      getTeamList()
    }
  }, [])


  function getTeamList() {
    console.log("getTeamList")
    if (setIsLoading !== undefined)
      setIsLoading(true)
    // console.log(mReqTeamList)
    api_getTeamListArray({
      success: (obj) => {
        console.log(obj)
        set_team_attr(obj.list)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function getDetail(mReqLeagueDetail) {
    console.log(mReqLeagueDetail)
    setIsLoading(true)
    api_getLeagueDetail({
      mReqLeagueDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespClient = new RespClient({})
        mRespClient.fromJson(jsonData.detail)

        set_team_name(mRespClient.team_name)
        set_startDate(moment(mRespClient.startDate).format('YYYY-MM-DD'))
        set_endDate(moment(mRespClient.endDate).format('YYYY-MM-DD'))

        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function toCancel() {
    window.history.back();
  }


  const checkDateError = (isError, errString) => {
    if (!dateError) {
      console.log("沒有")
      console.log(isError)
      setDateError(isError)
    } else {
      console.log("已有")
      console.log(isError)
      if (dateErrorArr.length === 0)
        setDateError(isError)
    }
    var errors = dateErrorArr.filter(error => {
      return error !== errString
    })
    if (isError && errString !== "") {
      errors.push(errString)
    }
    console.log(errors)
    setDateErrorArr(errors)
  }

  function toAdd() {
    if(!isAdd){
      toEdit()
      return
    }
    var inputError = []
    var errMessage = []
    if (team_id === "") {
      inputError.push("球隊")
    }
    if (admin === "") {
      inputError.push("管理員帳號")
    } else {
      var regex = new RegExp("^[a-zA-Z][a-zA-Z0-9_]{3,9}$");
      if (!regex.test(admin))
        errMessage.push("管理員帳號，只能使用10位數英數組合")
    }
    if (startDate === "") {
      inputError.push("起日期")
    }
    if (endDate === "") {
      inputError.push("迄日期")
    }

    if (startDate !== "" && endDate !== "") {
      if (!moment(startDate).isBefore(endDate)) {
        errMessage.push("起日期 必須 早於迄日")
      }
    }

    if (actCodeCap === 0) {
      inputError.push("使用人數上限")
    }

    if (inputError.length > 0 || errMessage.length > 0) {
      var msg = ''
      if (inputError.length > 0)
        msg += inputError.join(',') + ' 為必填';
      if (errMessage.length > 0) {
        if (msg !== '')
          msg += '<br>'
        msg += errMessage.join('<br>')
      }
      Swal.fire({
        type: 'error',
        title: '提醒',
        html: msg,
      })
      return
    }

    setIsLoading(true)
    var mRespClient = new RespClient({
      team_id,
      team_name,
      startDate,
      endDate,
      admin,
      actCodeCap
    })

    console.log(mRespClient)
    api_addClient({
      mRespClient,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '授權球隊新增成功，記得要再去啟用及建立啟動碼',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function toEdit(){

    var inputError = []
    var errMessage = []
    if (startDate === "") {
      inputError.push("起日期")
    }
    if (endDate === "") {
      inputError.push("迄日期")
    }

    if (startDate !== "" && endDate !== "") {
      if (!moment(startDate).isBefore(endDate)) {
        errMessage.push("起日期 必須 早於迄日")
      }
    }
    if (inputError.length > 0 || errMessage.length > 0) {
      var msg = ''
      if (inputError.length > 0)
        msg += inputError.join(',') + ' 為必填';
      if (errMessage.length > 0) {
        if (msg !== '')
          msg += '<br>'
        msg += errMessage.join('<br>')
      }
      Swal.fire({
        type: 'error',
        title: '提醒',
        html: msg,
      })
      return
    }

    setIsLoading(true)
    var mRespClient = new RespClient({
      team_id,
      startDate,
      endDate,
      actCodeCap,
      activation
    })

    console.log(mRespClient)
    api_updateClient({
      mRespClient,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '授權球隊編輯成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = isAdd?"授權球隊新增":"授權球隊編輯"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          {isAdd ?
            <SingleSelect title={"球隊名稱"}
              val={team_id}
              attr={team_attr}
              action={set_team_id}
              valType={SELECT_VAL_TYPE_STRING}
              hasBlank={true}
              blankVal={0}
              size={4}
              v={'team_id'}
              n={'team_name'}
            />
            : <SingleText title={"球隊名稱"} val={team_name} size={4} />
          }
          {isAdd ?
            <SingleInput title={"管理員帳號"} val={admin} action={set_admin} placeholder={"10位數英數組合"} size={4} />
            : <SingleText title={"管理員帳號"} val={admin} size={4} />
          }


        </div>
        <Space />
        <Space />
        <Space />
        <Space />
        <div className="col-md-12">
          <SingleDatePickerInput
            title={"起日期"}
            value={startDate}
            action={set_startDate}
            feedback={checkDateError}
            errString={"起日期"}
          />
          <SingleDatePickerInput
            title={"迄日期"}
            value={endDate}
            action={set_endDate}
            feedback={checkDateError}
            errString={"起日期"}
          />
        </div>
        <Space />
        <Space />
        <Space />
        <Space />
        <div className="col-md-12">
          <SingleInput title={"使用人數上限"} val={actCodeCap} action={set_actCodeCap} placeholder={"75"} size={2} type={"number"} />

          {isAdd ?<></>:
          <SingleRedio title={"啟用狀態"}
                    arr={isDisableItems}
                    val={activation} action={set_activation} />
          }
        </div>
      </div>



    </>

  var footer =
    <div className="row">
      <div className="col-md-12">
        <div className="col-sm-3 col-sm-offset-9">
          <CancelSubmitButton cancelAction={toCancel} submitName={"確定"} submitAction={toAdd} isRight={true} />
        </div>
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={false} />
      <SystemPromptInput />
    </>
  )
}